export default __webpack_public_path__ + "static/media/AvenirLTProMedium.f1b1a597.otf";